import NEW_YORK from "./cities/newYork";

const CITIES = [NEW_YORK];

const citiesById = CITIES.reduce((acc, city) => {
	acc[city.id] = city;
	return acc;
}, {});

export function getCityPack(cityId) {
	return citiesById[cityId] || null;
}

export function getAllCities() {
	return CITIES;
}

export { NEW_YORK };
export default CITIES;
